import { render, staticRenderFns } from "./App.vue?vue&type=template&id=2faad43b&scoped=true&"
import script from "./App.vue?vue&type=script&lang=ts&"
export * from "./App.vue?vue&type=script&lang=ts&"
import style0 from "@/styles/main.scss?vue&type=style&index=0&prod&lang=scss&"
import style1 from "./App.vue?vue&type=style&index=1&id=2faad43b&prod&lang=scss&"
import style2 from "./App.vue?vue&type=style&index=2&id=2faad43b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2faad43b",
  null
  
)

export default component.exports